import { type FunctionComponent } from "react";
import classnames from "classnames";

import { BetSegmentsSize } from "../BetSegments/BetSegments.types";
import { SelectionSegment } from "../BetSegments/snowflakes/SelectionSegment/SelectionSegment.web";
import { SelectionSegmentOrientation } from "../BetSegments/snowflakes/SelectionSegment/SelectionSegment.types";

import { type OutcomeBetSegmentsProps } from "./OutcomeBetSegments.types";

import styles from "./OutcomeBetSegments.web.css";

export const OutcomeBetSegments: FunctionComponent<OutcomeBetSegmentsProps> = ({
  rows,
  size = BetSegmentsSize.LARGE,
  isOddsBoosted,
  neutralPnl,
  className,
}) => (
  <div className={classnames(styles.container, className)}>
    {rows
      .filter(({ term, value }) => term && value)
      .map(({ term, value, rawValue, previousValue }) => (
        <SelectionSegment
          key={term}
          size={size}
          isOdds={false}
          isOddsBoosted={isOddsBoosted}
          orientation={SelectionSegmentOrientation.ROW}
          term={term}
          value={value}
          rawValue={rawValue}
          previousValue={previousValue}
          neutralPnl={neutralPnl}
        />
      ))}
  </div>
);
